import React, { useContext, useState } from 'react';
import { Select } from 'semantic-ui-react';
import API, { ResponseManagement, ErrorManagement } from '../../../API';
import Utility from '../../../Utility';
import GlobalContext from '../../../contexts/GlobalContext';
import { toast } from 'react-toastify';

const formatHour = (hour) => {
  let arrivaHour = hour;
  if( arrivaHour !== null ){
    arrivaHour = arrivaHour.substr(0,5);
  }

  return arrivaHour;
}

const SelectBookingArrivalHour = ({bookingId, defaultValue, onUpdateSuccess}) => {
  const [globalContext] = useContext(GlobalContext);
  const [arrivalHourState, setArrivalHourState] = useState(formatHour(defaultValue))
  const [isLoading, setIsLoading] = useState(false)

  /**
   * @author Adrien T
   * @param globalContext
   * @returns array
   */
  const getTimeCheckIn = () => {
    let tabArrivalHour = [];

    // horraire debut
    let start = globalContext.establishment.checkInSlot.start;
    start = start.split(":");
    let dateStart = new Date();
    dateStart.setHours(start[0]);
    dateStart.setMinutes( start[1] - (start[1] % 15) );

    // horraire fin
    let end = globalContext.establishment.checkInSlot.end;
    end = end.split(":");
    if (end[0] == 0) { end[0] = 23; }
    let dateEnd = new Date();
    dateEnd.setHours(end[0]);
    dateEnd.setMinutes( end[1] - (end[1] % 15) );

    for (let hour = dateStart.getHours(); hour < (dateEnd.getHours()+1); hour++) {
      for (let minute = 0; minute < 60; minute = (minute + 15) ) {

        if( hour == dateStart.getHours() && minute < dateStart.getMinutes() ) {
          continue;
        }
        if( hour == dateEnd.getHours() && minute > dateEnd.getMinutes() ) {
          continue;
        }
        let hour2 = ( hour < 10 ? '0' : '' ) + hour;
        let minute2 = ( minute < 10 ? '0' : '' ) + minute;
        tabArrivalHour.push(
          {
            key: hour2 + ":" + minute2,
            value: hour2 + ":" + minute2,
            text: hour2 + ":" + minute2,
          }
        )

      }
    }

    return tabArrivalHour;
  }

  const handleClickUpdateArrivalHour = (_, data) => {
    setIsLoading(true)

    let dataToSend = new URLSearchParams({
      bookingId: bookingId,
      arrivalHour: data.value,
    });

    API.post(Utility.getUrlAjax() + `/updateArrivalHour`, dataToSend)
    .then(response => {
      ResponseManagement(response,
        () => {
          toast.success(response.data.data.message ?? 'Success');
          onUpdateSuccess(data.value)
          setArrivalHourState(data.value)
        },
        () => {
          toast.error(response.data.data.message);
          setArrivalHourState(formatHour(defaultValue));
        }
      );
    })
    .catch(error => {
      ErrorManagement(error, () => {
        setArrivalHourState(formatHour(defaultValue));
      });
    })
    .finally(() => setIsLoading(false))
  }

  return (
    <>
      <Select
        onChange={handleClickUpdateArrivalHour}
        placeholder="HH:MM"
        options={[{ key: 1, value: '', text: '...' }, ...getTimeCheckIn()]}
        button
        basic
        loading={isLoading}
        className='icon mini short compact mx-3'
        floating
        labeled
        value={arrivalHourState}
        icon='clock'
      />
    </>
  );
}

export default SelectBookingArrivalHour;